export function isSafari(): boolean {
  const ua = navigator.userAgent;

  // Must contain "Safari"
  const isSafari = ua.includes("Safari");

  // Must NOT contain these (Chrome, Edge, Firefox variants)
  const isNotChrome = !ua.includes("Chrome") && !ua.includes("Chromium");
  const isNotCriOS = !ua.includes("CriOS"); // Chrome on iOS
  const isNotFxiOS = !ua.includes("FxiOS"); // Firefox on iOS
  const isNotEdgiOS = !ua.includes("EdgiOS"); // Edge on iOS

  return isSafari && isNotChrome && isNotCriOS && isNotFxiOS && isNotEdgiOS;
}

export function isAndroid(): boolean {
  return /Android/i.test(navigator.userAgent);
}
